import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Card, CardBody, CardHeader, Col, FormGroup, InputGroup, InputGroupAddon, Row} from "reactstrap";
import BodyForMaintenancesSelect from "../BodyForMaintenancesSelect";
import useAfterUpdateEffect from "../../../../utils/useAfterUpdateEffect";
import InputNumber from "../../../Application/ApplicationTable/InputNumber";
import AppDatePicker from "../../../../componentsReusable/AppDatePicker";
import moment from "moment";
import Filters from "./Stage1/Filters";
import ServiceProposalCooGroupSelect from "../ServiceProposalCooGroupSelect";
import Step3 from "./Stage1/Step3";
import {useTranslation} from "react-i18next";

const Stage1 = props => {
  const { t } = useTranslation('tec_rmi');
  
  const [data, setData] = useState(props.initialData ?? {
    bodyForMaintenances: null,
    mileage: props.mileage,
    firstRegistrationDate: props.firstRegistrationDate,
    filters: {},
    cooGroupId: props.cooGroupId,
    serviceProposal: null,
    serviceProposalOption: props.serviceProposalOption,
  })

  useAfterUpdateEffect(() => {
    props.onDataChange(data)
  }, [data])

  useAfterUpdateEffect(() => {
    props.nextStage()
  }, [data.serviceProposal])

  const getInitalRegistrationDate = () => {
    if(!data.firstRegistrationDate){
      return null
    }

    return moment(data.firstRegistrationDate).subtract(1, 'days').endOf('month').format('YYYY-MM-DD') + 'T23:00:00.000Z'
  }

  return (
    <Row>
      <Col md={4}>
        <Card>
          <CardHeader>{t('service_proposal.stage_1.step1.title')}</CardHeader>
          <CardBody>
            <BodyForMaintenancesSelect
              onChange={bodyForMaintenances => setData({...data, bodyForMaintenances})}
            />
            <FormGroup>
              <AppDatePicker
                openTo={'year'}
                placeholder={t('service_proposal.stage_1.step1.year')}
                maxDate={moment()}
                monthSelect
                value={data.firstRegistrationDate}
                onChange={firstRegistrationDate => setData({...data, firstRegistrationDate})}
              />
            </FormGroup>
            <FormGroup>
              <InputGroup>
                <InputNumber
                  autoFocus={false}
                  size={'md'}
                  placeholder={t('service_proposal.stage_1.step1.mileage')}
                  onChange={mileage => setData({...data, mileage})}
                  value={data.mileage}
                />
                <InputGroupAddon addonType={'append'}>km</InputGroupAddon>
              </InputGroup>
            </FormGroup>
            <FormGroup>
              <Filters
                onFiltersChange={filters => setData({...data, filters})}
                value={data.filters}
              />
            </FormGroup>
          </CardBody>
        </Card>
      </Col>
      <Col md={4}>
        <Card>
          <CardHeader>{t('service_proposal.stage_1.step2.title')}</CardHeader>
          <CardBody>
            <ServiceProposalCooGroupSelect
              isDisabled={!data.firstRegistrationDate}
              filters={data.filters}
              initalRegistrationDate={getInitalRegistrationDate()}
              onChange={cooGroupId => setData({...data, cooGroupId})}
              value={data.cooGroupId}
            />
          </CardBody>
        </Card>
      </Col>
      <Col md={4}>
        <Card>
          <CardHeader>{t('service_proposal.stage_1.step3.title')}</CardHeader>
          <CardBody>
            <Step3
              bodyForMaintenances={data.bodyForMaintenances}
              cooGroupId={data.cooGroupId}
              mileage={data.mileage}
              initalRegistrationDate={getInitalRegistrationDate()}
              serviceProposalOption={data.serviceProposalOption}
              onChooseServiceProposal={(serviceProposal, serviceProposalOption) => setData({...data, serviceProposal, serviceProposalOption})}
            />
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

Stage1.defaultProps = {
  mileage: null,
  firstRegistrationDate: '',
  cooGroupId: null,
  serviceProposalOption: null,
};

Stage1.propTypes = {
  mileage: PropTypes.number,
  firstRegistrationDate: PropTypes.string,
  cooGroupId: PropTypes.number,
  serviceProposalOption: PropTypes.string,
  nextStage: PropTypes.func.isRequired,
  onDataChange: PropTypes.func.isRequired,
};

export default Stage1;